import CatalogPdfView from 'src/sections/admin/catalog-pdf/view/catalog-pdf-view';

export default function CatalogPdfPage() {
  return <CatalogPdfView />;
}
